import { render, staticRenderFns } from "./ValidationSection.vue?vue&type=template&id=98632c96&"
import script from "./ValidationSection.vue?vue&type=script&lang=js&"
export * from "./ValidationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports